<template>
    <div>

      <div @click="doClick">
        <div class="in-bl-v-m" style="margin-right: 4px;">
        <span :class="{'up_down_active': tabIndex}">
          {{title}}
        </span>
        </div>

      <div class="in-bl-v-m" style="font-size: 0;">

      <div v-if="!hide_arrow">
        <div :class="{'up_down':true, 'up_down_active': tabIndex == 1}" style="transform: rotate(90deg);display: inline-block;">
          <van-icon name="play" />
        </div>
<br/>
        <div :class="{'up_down':true, 'up_down_active': tabIndex == 2}" style="transform: rotate(-90deg);display: inline-block;">
          <van-icon name="play" />
        </div>
      </div>
      </div>

      </div>
      </div>
</template>

<script>
    export default {
        name: 'CheeseFooter',
        props: [
            'title',
            'hide_arrow'
        ],
        data:function()
        {
          return {
            tabIndex: ''
          }
        },
        created:function()
        {
            console.log(this.footerType);
        },
        methods:{
          doClick()
          {
            if( this.tabIndex == 1)
            {
              this.tabIndex = 2
            }else
            {
              this.tabIndex = 1
            }

            this.$emit('ok', {})
          },
          clearIndex()
          {
            this.tabIndex = false
          },
          getIndex()
          {
            if( this.tabIndex )
            {
              return this.tabIndex
            }

            return false
          }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .cheese_footer
    {
        font-family: PingFangSC-Regular;
        font-size: 0.3125rem;
        color: #B2B2B2;
        text-align: center;
        line-height: 0.4375rem;
    }

    .up_down{
      color: #666666;
      font-size: 12px;
    }

    .up_down_active{
      color: #ff2030;
    }

    .fix_footer{
        position: fixed;
        left:0;
        right: 0;
        bottom: .5rem;
        text-align: center;
        z-index: -1;
    }

    .bottom_footer{
        margin-bottom: .5rem;
        margin-top: .5rem;
    }


</style>
